import React from 'react';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { ProposalsCard } from './ProposalsCard';
import { CustomerInfoCards } from './CustomerInfoCards';
import { GeneralTabFallback } from './GeneralTabFallback';
import { ActiveOpportunitiesCard } from './ActiveOpportunitiesCard';
import { CompanyInformationCard } from './CompanyInformationCard';
import { useGeneralTabDataFetch } from '../../../../../hooks/useGeneralTabDataFetch';

export const CustomerDetailsGeneralTab = () => {
  const { id: customerAccountId } = useParams<{ id: string }>();

  const { isLoading, customerDetails, customerContacts, customerOpportunities, customerProposals } =
    useGeneralTabDataFetch(customerAccountId);

  return (
    <RenderWithFallback isLoading={isLoading} fallBack={<GeneralTabFallback />}>
      <Stack gap={1}>
        <RenderWithCondition condition={customerDetails}>
          <CustomerInfoCards customerDetails={customerDetails} />
          <CompanyInformationCard customerDetails={customerDetails} customerContacts={customerContacts} />
          <ActiveOpportunitiesCard customerOpportunities={customerOpportunities} />
          <ProposalsCard customerProposals={customerProposals} />
        </RenderWithCondition>
      </Stack>
    </RenderWithFallback>
  );
};
